/* Stationary, per-line marks from the approved pen study. No canvas or image assets. */
(() => {
  const selector = [
    '.fd-menu-link', '.fd-single-info h3 > a', 'a[ref="productTitleLink"]',
    '.fd-text-link', '.fd-collector-paths a', '.fd-footer-bottom a',
    '.fd-footer-utility a', '.fd-dispatch-more', '.fd-shop-controls nav a',
    '.reference-breadcrumb a', '.shopify-policy__body a', '.product-details .rte a'
  ].join(',');
  const records = new WeakMap();
  const links = new Set();
  let pending = 0;
  function styleMark(link, fresh = false) {
    const record = records.get(link);
    if (!record) return;
    if (fresh || !record.seed) record.seed = Math.floor(Math.random() * 2147483646) + 1;
    let seed = record.seed;
    const random = () => ((seed = seed * 16807 % 2147483647) - 1) / 2147483646;
    const between = (min,max) => (min+(max-min)*random()).toFixed(3);
    record.art.querySelectorAll('.fd-pen-line').forEach(line => {
      const values = {
        '--pen-angle':`${between(-1.05,.7)}deg`, '--pen-skew':`${between(-1.2,1.2)}deg`,
        '--pen-tilt':`${between(99,110)}deg`, '--pen-overlap':`${between(179,187)}deg`,
        '--pen-density':between(.92,1.06), '--pen-left-peak':`${between(1.9,3.1)}%`,
        '--pen-left-fade':`${between(5,8)}%`, '--pen-right-start':`${between(89,94)}%`,
        '--pen-right-peak':`${between(95,97)}%`, '--pen-left-ink':between(.82,1),
        '--pen-mid-ink':between(.44,.64), '--pen-end-wash':between(.16,.31),
        '--pen-right-ink':between(.5,.85),
        '--pen-radius':`${between(2,4)}px ${between(2,5)}px ${between(1,3)}px ${between(2,4)}px / ${between(2,4)}px ${between(1,3)}px ${between(2,5)}px ${between(1,3)}px`
      };
      for (const [name,value] of Object.entries(values)) line.style.setProperty(name,value);
    });
  }
  function draw(link) {
    const record = records.get(link);
    if (!record || !link.isConnected) return;
    const {surface,label,art} = record;
    if (!surface.getClientRects().length) return;
    const origin = surface.getBoundingClientRect();
    if (!origin.width) return;
    const rects = [...label.getClientRects()].filter(r => r.width > 0);
    const signature = rects.map(r => [r.left-origin.left,r.top-origin.top,r.width,r.height].map(n=>n.toFixed(2)).join(',')).join(';');
    if (record.signature === signature) return;
    record.signature = signature;
    const fragment = document.createDocumentFragment();
    rects.forEach((r,i) => {
      const mark = document.createElement('span');
      mark.className = 'fd-pen-line';
      mark.style.cssText = `left:${r.left-origin.left-surface.clientLeft-6}px;top:${r.top-origin.top-surface.clientTop-3}px;width:${r.width+12}px;height:${r.height+6}px;--line-delay:${i*35}ms`;
      fragment.append(mark);
    });
    art.replaceChildren(fragment);
    styleMark(link);
  }
  function bind(root = document) {
    const candidates = root instanceof Element && root.matches(selector) ? [root,...root.querySelectorAll(selector)] : [...root.querySelectorAll(selector)];
    candidates.forEach(link => {
      if (records.has(link)) return;
      // Native product title links use display:contents; draw on the heading box.
      const surface = link.querySelector('[role="heading"]') || link;
      if (!surface.textContent.trim() || surface.querySelector('img,input,button')) return;
      const label = document.createElement('span');
      label.className = 'fd-link-label';
      label.append(...surface.childNodes);
      const art = document.createElement('span');
      art.className = 'fd-pen-art';
      art.setAttribute('aria-hidden','true');
      surface.append(art,label);
      surface.classList.add('fd-ink-surface');
      link.classList.add('fd-ink-link');
      if (link.closest('.shopify-policy__body,.product-details .rte')) link.classList.add('fd-ink-prose');
      records.set(link,{surface,label,art});
      links.add(link);
      draw(link);
    });
  }
  function refresh() {
    cancelAnimationFrame(pending);
    pending = requestAnimationFrame(() => {
      for (const link of links) {
        if (!link.isConnected) {links.delete(link);continue;}
        // A section renderer can retain the anchor but replace its descendants.
        if (!records.get(link).label.isConnected) {
          records.delete(link);links.delete(link);bind(link);continue;
        }
        draw(link);
      }
    });
  }
  document.addEventListener('pointerover',event => {
    const link = event.target.closest?.('.fd-ink-link');
    if (!link || event.pointerType === 'touch' || !matchMedia('(hover:hover)').matches || link.contains(event.relatedTarget)) return;
    draw(link);styleMark(link,true);
  });
  document.addEventListener('focusin',event => {
    const link = event.target.closest?.('.fd-ink-link');
    if (link && !link.matches(':hover')) {draw(link);styleMark(link,true);}
  });
  document.addEventListener('fd:menu-open',refresh);
  document.addEventListener('shopify:section:load',event => {bind(event.target);refresh();});
  document.addEventListener('shopify:section:unload',refresh);
  document.fonts.ready.then(refresh);
  window.addEventListener('resize',refresh,{passive:true});
  const observer = new MutationObserver(mutations => {
    let changed = false;
    for (const mutation of mutations) {
      // Ignore our own mark construction, while catching native catalog/cart renders.
      if (mutation.target instanceof Element && mutation.target.closest('.fd-pen-art,.fd-link-label')) continue;
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element) || node.matches('.fd-pen-art,.fd-link-label')) continue;
        bind(node);changed = true;
      }
      if (mutation.removedNodes.length) changed = true;
    }
    if (changed) refresh();
  });
  bind();
  observer.observe(document.body,{childList:true,subtree:true});
})();
